import React, { useState, createContext } from "react";

// Create Context Object
export const MapContext = createContext();

// Create a provider for components to consume and subscribe to changes
export const MapContextProvider = (props) => {
  const [map, setMap] = useState(null);

  return (
    <MapContext.Provider value={[map, setMap]}>
      {props.children}
    </MapContext.Provider>
  );
};
